import * as React from "react";
import {
  Box, List, ListItemButton, ListItemText, Typography, Divider, CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import { listSchedules, type ScheduleSummary } from "../../api/schedules";

const MAX_SHOWN = 3;

export function SchedulesSection() {
  const [schedules, setSchedules] = React.useState<ScheduleSummary[] | null>(null);

  React.useEffect(() => {
    listSchedules()
      .then(setSchedules)
      .catch(() => setSchedules([]));
  }, []);

  if (schedules === null) {
    return (
      <Box sx={{ p: 1, textAlign: "center" }}>
        <CircularProgress size={16} />
      </Box>
    );
  }

  const shown = schedules.slice(0, MAX_SHOWN);
  const overflow = schedules.length - shown.length;

  return (
    <div>
      <Typography
        variant="overline"
        sx={{ display: "block", px: 2, pt: 1, color: "text.secondary" }}
      >
        Schedules
      </Typography>
      <List dense>
        {shown.map((s) => (
          <ListItemButton
            key={s.id}
            component={Link}
            to="/workspace/schedules"
          >
            <ListItemText
              primary={s.name}
              slotProps={{ primary: { noWrap: true } }}
            />
          </ListItemButton>
        ))}
        {overflow > 0 && (
          <ListItemButton component={Link} to="/workspace/schedules">
            <ListItemText
              primary={`${overflow} more →`}
              slotProps={{ primary: { color: "text.secondary" } }}
            />
          </ListItemButton>
        )}
        {schedules.length === 0 && (
          <ListItemButton component={Link} to="/workspace/schedules">
            <ListItemText
              primary="View schedules"
              slotProps={{ primary: { color: "text.secondary" } }}
            />
          </ListItemButton>
        )}
      </List>
      <Divider />
    </div>
  );
}
